import { render } from "./DisplayArticle.vue?vue&type=template&id=569393c2&scoped=true"
import script from "./DisplayArticle.vue?vue&type=script&lang=js"
export * from "./DisplayArticle.vue?vue&type=script&lang=js"

import "./DisplayArticle.vue?vue&type=style&index=0&id=569393c2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569393c2"]])

export default __exports__